var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "flex-box justify-space-between align-items-center"
  }, [_c('div', {
    staticClass: "flex-box align-items-center",
    staticStyle: {
      "gap": "12px"
    }
  }, [_vm.showBackBtn ? _c('span', {
    staticClass: "el-icon-arrow-left back-icon",
    on: {
      "click": function ($event) {
        return _vm.$router.back();
      }
    }
  }) : _vm._e(), _c('el-breadcrumb', {
    attrs: {
      "separator": "/"
    }
  }, _vm._l(_vm.crumb, function (item, index) {
    return _c('el-breadcrumb-item', {
      key: _vm.getCrumbKey(item, index)
    }, [_c('span', {
      class: {
        'header-crumb-clickable': _vm.isCrumbClickable(item, index)
      },
      on: {
        "click": function ($event) {
          return _vm.handleCrumbClick(item, index);
        }
      }
    }, [_vm._v(" " + _vm._s(_vm.getCrumbLabel(item)) + " ")])]);
  }), 1)], 1), _vm._t("form")], 2);
};
var staticRenderFns = [];
export { render, staticRenderFns };